module.exports = __webpack_public_path__ + "img/new3.392155ab.png";